/**
 * Debe ser el primer import del entry (index.js).
 * Con REACT_APP_DEBUG distinto de 'true'/'1', silencia console para no exponer logs.
 * Con DEBUG activo, filtra solo el error cosmético de ResizeObserver.
 */
const DEBUG = process.env.REACT_APP_DEBUG === 'true' || process.env.REACT_APP_DEBUG === '1';

if (!DEBUG) {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
} else {
  const originalError = console.error;
  console.error = function (...args) {
    if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
      return;
    }
    originalError.apply(console, args);
  };
}
